export const Card = ({ title, children }) => <div className="card mb-3">
    {
        !!title && <h6 className="card-header">{title}</h6>
    }
    <div className="card-body">
        {children}
    </div>
</div>;